var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.36769C23.1075 2.76923 22.1565 3.03538 21.165 3.16462C22.185 2.54 22.9635 1.55846 23.3295 0.375385C22.3785 0.956923 21.3285 1.36769 20.2095 1.59692C19.3065 0.610769 18.0195 0 16.6155 0C13.8915 0 11.6985 2.26769 11.6985 5.04769C11.6985 5.44769 11.7315 5.83231 11.8125 6.19846C7.722 5.99385 4.1025 3.98308 1.671 0.92C1.2465 1.67538 0.9975 2.54 0.9975 3.47077C0.9975 5.21846 1.875 6.76769 3.183 7.66462C2.3925 7.64923 1.617 7.41385 0.96 7.04308C0.96 7.05846 0.96 7.07846 0.96 7.09846C0.96 9.55077 2.6655 11.5877 4.902 12.0569C4.5015 12.1692 4.065 12.2231 3.612 12.2231C3.297 12.2231 2.979 12.2046 2.6805 12.1369C3.318 14.1354 5.127 15.6046 7.278 15.6523C5.604 16.9954 3.4785 17.8046 1.1775 17.8046C0.774 17.8046 0.387 17.7862 0 17.7354C2.1795 19.1769 4.7625 20 7.548 20C16.602 20 21.552 12.3077 21.552 5.64C21.552 5.41692 21.5445 5.20154 21.534 4.98769C22.5105 4.27692 23.331 3.38923 24 2.36769Z",
    fill: "#FF583D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.44e4a7358de1c288b3d044b826dcf6d0.svg";
export { ForwardRef as ReactComponent };